import { render, staticRenderFns } from "./EditOrganizationUser.vue?vue&type=template&id=6799b84d&scoped=true&"
import script from "./EditOrganizationUser.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationUser.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganizationUser.vue?vue&type=style&index=0&id=6799b84d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6799b84d",
  null
  
)

export default component.exports